import React, {useContext, useEffect, useState, useRef} from "react";
import {CheckboxProps, Card, Checkbox, Col, List, Splitter} from "antd";
import {Chapter, StatusContext} from "../../../services/types";
import * as d3 from "d3";

const CompareLists: React.FC = () => {
    const svgRef = useRef<SVGSVGElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const statusContext = useContext(StatusContext);
    if (!statusContext) {
        throw new Error("missing context");
    }
    const {status, setStatus} = statusContext;

    const onChange: CheckboxProps['onChange'] = (e) => {
        const id = e.target.value;
        const checked = e.target.checked;

        const updatedLeftChapters = status.leftChapters?.map(cpt => {
            if (cpt.id === id) {
                return {...cpt, skipped: !checked};
            }
            return cpt;
        });

        const updatedRightChapters = status.rightChapters?.map(cpt => {
            if (cpt.id === id) {
                return {...cpt, skipped: !checked};
            }
            return cpt;
        });

        setStatus({
            ...status,
            leftChapters: updatedLeftChapters || status.leftChapters,
            rightChapters: updatedRightChapters || status.rightChapters,
        })
    };


    useEffect(() => {
        if (!svgRef.current || !containerRef.current) return;

        d3.select(svgRef.current).selectAll('*').remove();

        // Позиционирование SVG над контейнером
        const containerRect = containerRef.current.getBoundingClientRect();
        d3.select(svgRef.current)
            .attr('width', containerRect.width)
            .attr('height', containerRect.height);


        let rightI: number = 0;

        setTimeout(() => {

            status.leftChapters?.forEach((cpt: Chapter, i: number) => {
                if (cpt.skipped) return;
                // Ищем следующий используемый правый элемент
                while (status.rightChapters && rightI < status.rightChapters.length && status.rightChapters[rightI].skipped) {
                    rightI++;
                }

                // Проверяем, что мы не вышли за границы массива
                if (!status.rightChapters || rightI >= status.rightChapters.length) return;

                const rightCpt = status.rightChapters[rightI];

                const leftElement = document.getElementById(`left-${cpt.id}`);
                const rightElement = document.getElementById(`right-${rightCpt.id}`);


                if (!leftElement || !rightElement) return;

                const leftRect = leftElement.getBoundingClientRect();
                const rightRect = rightElement.getBoundingClientRect();

                // Относительные координаты
                const x1 = leftRect.right - containerRect.left;
                const y1 = leftRect.top + leftRect.height / 2 - containerRect.top;
                const x2 = rightRect.left - containerRect.left;
                const y2 = rightRect.top + rightRect.height / 2 - containerRect.top;

                // Создание кривой Безье
                const path = d3.path();
                path.moveTo(x1, y1);
                path.bezierCurveTo(
                    x1 + (x2 - x1) / 3, y1,
                    x2 - (x2 - x1) / 3, y2,
                    x2, y2
                );

                // Добавление линии в SVG
                d3.select(svgRef.current)
                    .append('path')
                    .attr('d', path.toString())
                    .attr('fill', 'none')
                    .attr('stroke', 'rgba(0, 0, 0, 0.5)')
                    .attr('stroke-width', 1);


                // Увеличиваем индекс для следующей итерации
                rightI++;
            })

        }, 100);

    }, [status.leftChapters, status.rightChapters]);

    return (
        <Col xs={24} xl={24}>
            <Card bordered={false}>
                <div style={{position: 'relative', width: '100%', height: '100%' }} ref={containerRef}>
                    <svg
                        ref={svgRef}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            pointerEvents: 'none',
                            zIndex: 1
                        }}
                    />
                    <Splitter>
                        <Splitter.Panel size={'50%'} resizable={false}>
                            <List
                                style={{marginRight: 24}}
                                bordered
                                dataSource={status.leftChapters}
                                renderItem={(cpt: Chapter) => (
                                    <List.Item id={`left-${cpt.id}`} key={cpt.id}>
                                        <Checkbox
                                            onChange={onChange}
                                            value={cpt.id}
                                            checked={!cpt.skipped}
                                        >
                                            {cpt.name}
                                        </Checkbox>
                                    </List.Item>
                                )}
                            />
                        </Splitter.Panel>
                        <Splitter.Panel size={'50%'}>
                            <List
                                style={{marginLeft: 24}}
                                bordered
                                dataSource={status.rightChapters}
                                renderItem={(cpt: Chapter) => (
                                    <List.Item id={`right-${cpt.id}`} key={cpt.id}>
                                        <Checkbox
                                            onChange={onChange}
                                            value={cpt.id}
                                            checked={!cpt.skipped}
                                        >
                                            {cpt.name}
                                        </Checkbox>
                                    </List.Item>
                                )}
                            />
                        </Splitter.Panel>
                    </Splitter>
                </div>
            </Card>
        </Col>
    )
}

export default CompareLists;